import {findNodes} from '../../lib/utility/dom-helpers';

export const makeVerticalTabs = (rootEl) => {
  let selectedIndex;
  const tabButtons = findNodes(rootEl, '.tab-button-container > .tab-button');
  const containers = findNodes(rootEl, '.tab-content-container > .tab-content');
  const state = {
    get selectedIndex () {
      return selectedIndex;
    },
    onChange () {
    }
  };

  containers.forEach((container) => container.classList.add('tab-content-hidden'));

  tabButtons.forEach((tabButton, ix) => tabButton.addEventListener('change', selectTab.bind(null, ix)));

  function selectTab (ix) {
    if (selectedIndex !== undefined) {
      containers[selectedIndex].classList.add('tab-content-hidden');
    }
    containers[ix].classList.remove('tab-content-hidden');
    selectedIndex = ix;
    state.onChange();
  }

  selectTab(0);

  return state;
};



// WEBPACK FOOTER //
// ./src/uScope/js/components/vertical-tabs/make-vertical-tabs.js